import { useInView } from 'react-intersection-observer';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import {
  TOP_BAR_HEIGHT_DESKTOP,
  TOP_BAR_HEIGHT_MOBILE,
} from '@xing-com/crate-jobs-constants';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';

type UseIsJobDetailHeaderInViewResult = {
  ref: (node?: Element | null) => void;
  refElement?: HTMLElement;
  isInView: boolean;
  isTopbarHidden: boolean | undefined;
};

export const useIsJobDetailHeaderInView =
  (): UseIsJobDetailHeaderInViewResult => {
    const isTopbarHidden = useMatchMedia(mediaTopBarHidden);
    const { entry, ref, inView } = useInView({
      initialInView: true,
      rootMargin: `-${isTopbarHidden ? TOP_BAR_HEIGHT_DESKTOP : TOP_BAR_HEIGHT_MOBILE}px`,
    });

    return {
      ref,
      // oxlint-disable-next-line typescript/consistent-type-assertions
      refElement: entry?.target as HTMLElement,
      isInView: inView,
      isTopbarHidden,
    };
  };
